import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserPage from 'flarum/forum/components/UserPage';
import LinkItem from 'flarum/common/components/LinkButton';
import LinkPage from './components/LinkPage';
import UserLauncherPage from './components/UserLauncherPage';

/**
 * Unlinked launcher: open the login modal on whatever page it shows, once per
 * pairing (the payload marker is a hash of the pair id, set server-side only for
 * a logged-out request with an open pairing). Dismissing it means "let me
 * browse": it is not reopened for that pairing. /launcher/link opens its own.
 *
 * Deferred past boot so the modal manager is mounted; LogInModal is a lazy
 * chunk in Flarum 2, so it is imported on demand (see LinkPage).
 */
function promptLauncherLogin() {
  // An explicit request (the launcher opens /?login=<n>): the person asked, so
  // the once-per-pairing rule does not apply. The parameter is dropped either
  // way so a refresh does not reopen it.
  const params = new URLSearchParams(window.location.search);
  if (params.has('login')) {
    params.delete('login');
    const qs = params.toString();
    try {
      window.history.replaceState(window.history.state, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
    } catch (e) {
      // Not worth failing over; the modal still opens.
    }
    if (!app.session.user) {
      app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'), {
        remember: true
      });
    }
    return;
  }
  const marker = app.data?.blizznuxLauncherLogin;
  if (!marker || app.session.user) return;
  if (app.current.get('routeName') === 'blizznux.launcher.link') return;
  const key = 'bnx-launcher-login-shown:' + marker;
  try {
    if (window.sessionStorage.getItem(key)) return;
    window.sessionStorage.setItem(key, '1');
  } catch (e) {
    // Storage blocked: show it anyway; worst case it shows again next load.
  }
  app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'), {
    remember: true
  });
}
app.initializers.add('blizznux-launcher', () => {
  setTimeout(promptLauncherLogin, 0);

  // Route names match extend.php. Flarum resolves the component from this map,
  // so a mismatch is a blank page with no error anywhere.
  app.routes['blizznux.launcher.link'] = {
    path: '/launcher/link',
    component: LinkPage
  };
  app.routes['blizznux.launcher.user'] = {
    path: '/u/:username/launcher',
    component: UserLauncherPage
  };

  // The tab is shown to the person themselves and to staff only — everyone
  // else gets 403 from the endpoint, and offering a tab that cannot load is
  // worse than not offering one.
  extend(UserPage.prototype, 'navItems', function (items) {
    const user = this.user;
    if (!user) return;
    const me = app.session.user;
    const isSelf = me && me.id() === user.id();
    const isStaff = me && (me.groups() || []).some(g => g && ['1', '4'].includes(String(g.id())));
    if (!isSelf && !isStaff) return;
    items.add('launcher', LinkItem.component({
      href: app.route('blizznux.launcher.user', {
        username: user.slug()
      }),
      icon: 'fas fa-gamepad'
    }, app.translator.trans('blizznux-launcher.forum.record.tab')), -10);
  });
});